import { BTSegmentedControl } from "commonComponents/btWrappers/BTSegmentedControl/BTSegmentedControl";

interface IJobPickerSegmentedControlProps {
    templatesOnly: boolean;
    onTemplateModeChanged: (templatesOnly: boolean, builderId: number) => void;
    builderId: number;
}

export function JobPickerSegmentedControl({
    templatesOnly,
    onTemplateModeChanged,
    builderId,
}: IJobPickerSegmentedControlProps) {
    return (
        <BTSegmentedControl
            testid="job-picker-toggle"
            aria-label="Job picker"
            value={templatesOnly ? "templates" : "jobs"}
            onValueChange={(newValue) => {
                onTemplateModeChanged(newValue === "templates", builderId);
            }}
        >
            <BTSegmentedControl.Option testid="item-jobs" value="jobs">
                Jobs
            </BTSegmentedControl.Option>
            <BTSegmentedControl.Option testid="item-templates" value="templates">
                Templates
            </BTSegmentedControl.Option>
        </BTSegmentedControl>
    );
}
